import React from "react";
import removeImg from "assets/svgs/close.svg";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SliderItem from "./SliderItem";

const SlidersArray = ({ sliders, setSliders, countries }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider, index) => {
      if (index !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };

  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter((slider, index) => index !== sliderId);
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [
      ...(sliders || []),
      {
        heading: {
          en: "",
          ar: "",
        },
        boldHeading: {
          en: "",
          ar: "",
        },
        description: {
          en: "",
          ar: "",
        },
        imageTitle: {
          en: "",
          ar: "",
        },
        countryId: "",

        image: "",
      },
    ]);
  };

  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        {sliders?.map((slider, index) => {
          return (
            <SliderItem
              countries={countries}
              slider={slider}
              setSliders={setSliders}
              handleInputOnChange={handleInputOnChange}
              removeSlider={removeSlider}
              index={index}
              removeImg={removeImg}
            />
          );
        })}

        <Row>
          <Col lg={4} xs={12} className="text-left">
            <button
              type="button"
              className="btn btn-green add_new_section__"
              onClick={() => {
                addSlider();
              }}
            >
              <FormattedMessage id={"addSlider"} />
            </button>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default SlidersArray;
